/**
 * Single source of truth for legal/company details referenced across the
 * Terms, Privacy Policy, Community Guidelines, Cookie Notice, and footer.
 *
 * Everything in square brackets is a PLACEHOLDER that must be replaced with
 * confirmed, lawyer-reviewed values before these documents are published.
 * Keeping them as visible placeholders guarantees no wrong/broken contact
 * detail (e.g. a malformed email) ever goes live by accident.
 *
 * See documentation/UX_REVIEW_FOLLOWUPS.md (#5) and the founder-decision list.
 */
export const legalConfig = {
  brandName: 'RoomZa',
  entityName: 'Roomzaa (Pty) Ltd',
  entityForm: 'private company',
  registrationNumber: '2026-062657',
  physicalAddress: '[PHYSICAL ADDRESS]',
  telephone: '[TELEPHONE NUMBER]',
  websiteUrl: 'https://roomzza.com/',
  launchMarket: 'South Africa',

  // Countries where personal information is processed. NOTE: Cloud Functions
  // run in us-central1 and Firebase/Google Cloud stores data in Google regions,
  // so processing is not South-Africa-only. Confirm the actual Firestore/RTDB
  // region and update this if you move infrastructure.
  processingCountries: 'South Africa and the United States (Google Cloud / Firebase infrastructure)',

  // Contact addresses. Currently all routed to the one confirmed mailbox; split
  // into dedicated role-based addresses (support@, privacy@, ...) when they exist.
  supportEmail: 'Shaun@roomzaaa.co.za',
  privacyEmail: 'Shaun@roomzaaa.co.za',
  securityEmail: 'Shaun@roomzaaa.co.za',
  legalEmail: 'Shaun@roomzaaa.co.za',

  // Information Officer (registered with the Information Regulator).
  informationOfficer: 'Shaun Mlangeni',
  informationOfficerEmail: 'Shaun@roomzaaa.co.za',
  // Prescribed PAIA request fees (per the PAIA regulations / your fee schedule).
  paiaRequestFee: '[PAIA REQUEST FEE]',

  // Publication dates — set to the actual go-live date at publish time.
  effectiveDate: '[EFFECTIVE DATE]',
  lastUpdated: '[LAST UPDATED]',

  // External references.
  infoRegulatorUrl: 'https://inforegulator.org.za/',

  // Bump when the legal documents change so we can record which version a
  // user accepted at signup.
  documentsVersion: '2026-07-21',
} as const;

export type LegalConfig = typeof legalConfig;
